module.exports = __webpack_public_path__ + "img/about_us.16039066.png";